module.exports = __webpack_public_path__ + "media/tycho2t3_80_pz.e4caa789.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/sky_box/tycho2t3_80_pz.jpg
// module id = 1093
// module chunks = 0